import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { computed } from 'vue';
import { i18n } from '@/locales';
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import Controller from '@V/OperationSetting/HistoryDialog/Controller.vue';
import HistoryTable from '@V/OperationSetting/HistoryDialog/HistoryTable.vue';
import vuexStore from '@/vuex-store';
import { operationSettingHistoryActionType } from '@/vuex-store/operation-setting-history/actions';
const lc = 'views.operation_setting_history.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const locales = {
            detailedHistory: i18n.t(`${lc}detailed_history`),
            title: i18n.t(`${lc}title`),
        };
        const isDialogOpen = computed(() => vuexStore.state.operationSettingHistory.isDialogOpen);
        /**
         * 다이얼로그 닫기
         */
        const handleCancelDialog = () => {
            vuexStore.dispatch(operationSettingHistoryActionType.setOpenHistoryDialog, false);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                "is-open": isDialogOpen.value,
                "on-cancel": handleCancelDialog,
                "is-divided": false,
                "has-footer": false,
                height: 696,
                "dialog-css-class": "width-md ratio-full"
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(locales.title), 1 /* TEXT */)
                ]),
                leftSubTitle: _withCtx(() => [
                    _createVNode(Controller)
                ]),
                leftContent: _withCtx(() => [
                    _createVNode(HistoryTable)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-open"]));
        };
    }
});
